import React, { useEffect } from 'react';

const JiraIssueCollector = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://rccl-idd.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/278rlr/b/7/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=es-ES&collectorId=5a3edfe6';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <div id="jira-issue-collector-container" data-testid="jira-issue-collector-container" />;
};

export default JiraIssueCollector;
